// Portuguese Language Pack
export default {
  // 检测部位
  part: {
    '车头': 'Parte dianteira',
    '发动机舱': 'Compartimento do motor',
    '左前车身': 'Carroçaria dianteira esquerda',
    '左前内饰': 'Interior dianteiro esquerdo',
    '左后车身': 'Carroçaria traseira esquerda',
    '左后内饰': 'Interior traseiro esquerdo',
    '车尾': 'Parte traseira',
    '后备箱内部': 'Interior da bagageira',
    '右后车身': 'Carroçaria traseira direita',
    '右后内饰': 'Interior traseiro direito',
    '右前车身': 'Carroçaria dianteira direita',
    '右前内饰': 'Interior dianteiro direito',
    '机电': 'Eletromecânica',
    '新能源检测': 'Inspeção de veículos de energia nova',
    '骨架': 'Estrutura',
    '外观': 'Exterior',
    '内饰': 'Interior',
    '其它': 'Outros',
    '其他': 'Outros',
    '水渍残留点': 'Manchas de água',
  },

  // 损伤等级颜色
  damageLevel: {
    '轻微损伤': 'Dano ligeiro',
    '严重损伤': 'Dano grave',
    '预检异常': 'Anomalia de pré-inspeção',
  },

  // 评分说明
  scoreRemark: {
    '车辆结构件与加强件均无因事故造成的损伤': 'Sem danos por acidente nos elementos estruturais e de reforço do veículo.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'Elementos estruturais sem danos por acidente; danos ligeiros por acidente nos elementos de reforço.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'Elementos estruturais sem danos por acidente; danos graves por acidente nos elementos de reforço.',
    '车辆结构件有因事故造成的损伤': 'Danos por acidente nos elementos estruturais.',
    '外观极差': 'Estado exterior extremamente mau',
    '内饰极差': 'Estado interior extremamente mau',
    '外观较差': 'Estado exterior mau',
    '内饰较差': 'Estado interior mau',
    '外观一般': 'Estado exterior razoável',
    '内饰一般': 'Estado interior razoável',
    '外观较好': 'Estado exterior bom',
    '内饰较好': 'Estado interior bom',
    '外观准新': 'Estado exterior quase novo',
    '内饰准新': 'Estado interior quase novo',
  },

  // 检测项名称
  inspectionItem: {
    '左前大灯': 'Farol dianteiro esquerdo',
    '左前雾灯': 'Luz de nevoeiro dianteira esquerda',
    '前底盘': 'Parte inferior dianteira',
    '前保险杠': 'Pára-choques dianteiro',
    '中网': 'Grelha do radiador',
    '发动机舱盖外侧': 'Face exterior do capô',
    '发动机舱盖内侧': 'Face interior do capô',
    '水箱框架': 'Estrutura do radiador',
    '前防撞梁': 'Viga do pára-choques dianteiro',
    '左前纵梁': 'Longarina dianteira esquerda',
    '左前翼子板骨架': 'Guarda-lamas interior dianteiro esquerdo',
    '左前减震器支座': 'Torre do amortecedor dianteiro esquerdo',
    '防火墙': 'Tabique corta-fogo',
    '车架号': 'Número de chassis (VIN)',
    '右前减震器支座': 'Torre do amortecedor dianteiro direito',
    '右前翼子板骨架': 'Guarda-lamas interior dianteiro direito',
    '右前纵梁': 'Longarina dianteira direita',
    '发动机变速箱及附件': 'Motor, caixa de velocidades e acessórios',
    '机油': 'Óleo do motor',
    '防冻液': 'Líquido de refrigeração',
    '刹车油': 'Líquido dos travões',
    '电池': 'Bateria',
    '皮带': 'Correia',
    '保险丝盒': 'Caixa de fusíveis',
    '发动机线束': 'Feixe de cabos do motor',
    '左前轮胎': 'Pneu dianteiro esquerdo',
    '左前轮毂': 'Jante dianteira esquerda',
    '左前避震器': 'Amortecedor dianteiro esquerdo',
    '左前轮内衬罩': 'Forro do vão da roda dianteiro esquerdo',
    '左前翼子板': 'Guarda-lamas dianteiro esquerdo',
    '左后视镜': 'Espelho lateral esquerdo',
    '前风挡玻璃': 'Pára-brisas dianteiro',
    '左A柱外侧': 'Pilar A esquerdo exterior',
    '左前车顶': 'Teto dianteiro esquerdo',
    '左前门玻璃': 'Vidro da porta dianteira esquerda',
    '左前门外侧': 'Painel exterior da porta dianteira esquerda',
    '左前门裙边外侧': 'Lateral exterior do umbral da porta dianteira esquerda',
    '左前门内侧': 'Painel interior da porta dianteira esquerda',
    '左前门内饰（含胶条）': 'Forro da porta dianteira esquerda (inclui vedantes)',
    '左A柱内侧': 'Pilar A esquerdo interior',
    '左前门裙边内侧': 'Lateral interior do umbral da porta dianteira esquerda',
    '主驾座椅区域': 'Zona do banco do condutor',
    '主驾座椅滑轨': 'Carril do banco do condutor',
    '主驾安全带': 'Cinto de segurança do condutor',
    '左前地毯（含周边饰条、饰板）': 'Tapete dianteiro esquerdo (inclui frisos e painéis circundantes)',
    '转向管柱': 'Coluna de direção',
    '方向盘': 'Volante',
    '仪表盘': 'Painel de instrumentos',
    '中控台': 'Consola central',
    '前排扶手区域': 'Zona do apoio de braços dianteiro',
    '主驾仪表台': 'Tablier do condutor',
    '左A柱内饰板': 'Forro do pilar A esquerdo',
    '左前顶棚（含前排天窗饰板、遮阳板）': 'Teto dianteiro esquerdo (inclui forro do teto de abrir e palas de sol)',
    '前排天窗': 'Teto de abrir dianteiro',
    '内后视镜区域': 'Zona do espelho retrovisor',
    '左后轮胎': 'Pneu traseiro esquerdo',
    '左后轮毂': 'Jante traseira esquerda',
    '左后避震器': 'Amortecedor traseiro esquerdo',
    '左后轮内衬罩': 'Forro do vão da roda traseiro esquerdo',
    '左后翼子板': 'Guarda-lamas traseiro esquerdo',
    '左C柱外侧': 'Pilar C esquerdo exterior',
    '左后车顶': 'Teto traseiro esquerdo',
    '左B柱外侧': 'Pilar B esquerdo exterior',
    '左后门玻璃': 'Vidro da porta traseira esquerda',
    '左后门外侧': 'Painel exterior da porta traseira esquerda',
    '左后门裙边外侧': 'Lateral exterior do umbral da porta traseira esquerda',
    '左后门内侧': 'Painel interior da porta traseira esquerda',
    '左后门内饰（含胶条）': 'Forro da porta traseira esquerda (inclui vedantes)',
    '左C柱内侧': 'Pilar C esquerdo interior',
    '左B柱内侧': 'Pilar B esquerdo interior',
    '左后门裙边内侧': 'Lateral interior do umbral da porta traseira esquerda',
    '左后座椅区域': 'Zona do banco traseiro esquerdo',
    '左后座椅滑轨': 'Carril do banco traseiro esquerdo',
    '左后安全带': 'Cinto de segurança traseiro esquerdo',
    '左后地毯（含周边饰条、饰板）': 'Tapete traseiro esquerdo (inclui frisos e painéis circundantes)',
    '后排扶手区域': 'Zona do apoio de braços traseiro',
    '左B柱内饰板': 'Forro do pilar B esquerdo',
    '左C柱内饰板': 'Forro do pilar C esquerdo',
    '左后顶棚（含后排天窗饰板）': 'Teto traseiro esquerdo (inclui forro do teto de abrir traseiro)',
    '后排天窗': 'Teto de abrir traseiro',
    '后风挡玻璃': 'Vidro traseiro',
    '左D柱外侧': 'Pilar D esquerdo exterior',
    '右D柱外侧': 'Pilar D direito exterior',
    '后备箱盖外侧': 'Face exterior da tampa da bagageira',
    '左后尾灯': 'Farolim traseiro esquerdo',
    '右后尾灯': 'Farolim traseiro direito',
    '后保险杠': 'Pára-choques traseiro',
    '后防撞梁': 'Viga do pára-choques traseiro',
    '左后纵梁': 'Longarina traseira esquerda',
    '右后纵梁': 'Longarina traseira direita',
    '后底盘': 'Parte inferior traseira',
    '后备箱盖内侧': 'Face interior da tampa da bagageira',
    '后备箱盖内饰板（含胶条）': 'Forro da tampa da bagageira (inclui vedantes)',
    '后部导水槽': 'Caleira de drenagem traseira',
    '左D柱内饰板': 'Forro do pilar D esquerdo',
    '左D柱内侧': 'Pilar D esquerdo interior',
    '右D柱内饰板': 'Forro do pilar D direito',
    '右D柱内侧': 'Pilar D direito interior',
    '后窗台板': 'Prateleira traseira',
    '后备箱内饰（含胶条、地毯、周边饰条、饰板）': 'Forro da bagageira (inclui vedantes, tapete e frisos circundantes)',
    '后围板': 'Painel traseiro',
    '备胎轮胎': 'Pneu sobresselente',
    '备胎轮毂': 'Jante sobresselente',
    '工具': 'Ferramentas',
    '后备箱底板': 'Piso da bagageira',
    '左后翼子板骨架(包含减震器支座)': 'Guarda-lamas interior traseiro esquerdo (inclui torre do amortecedor)',
    '右后翼子板骨架(包含减震器支座)': 'Guarda-lamas interior traseiro direito (inclui torre do amortecedor)',
    '右后轮胎': 'Pneu traseiro direito',
    '右后轮毂': 'Jante traseira direita',
    '右后避震器': 'Amortecedor traseiro direito',
    '右后轮内衬罩': 'Forro do vão da roda traseiro direito',
    '右后翼子板': 'Guarda-lamas traseiro direito',
    '右C柱外侧': 'Pilar C direito exterior',
    '右后车顶': 'Teto traseiro direito',
    '右B柱外侧': 'Pilar B direito exterior',
    '右后门玻璃': 'Vidro da porta traseira direita',
    '右后门外侧': 'Painel exterior da porta traseira direita',
    '右后门裙边外侧': 'Lateral exterior do umbral da porta traseira direita',
    '右后门内侧': 'Painel interior da porta traseira direita',
    '右后门内饰（含胶条）': 'Forro da porta traseira direita (inclui vedantes)',
    '右C柱内侧': 'Pilar C direito interior',
    '右B柱内侧': 'Pilar B direito interior',
    '右后门裙边内侧': 'Lateral interior do umbral da porta traseira direita',
    '右后座椅区域': 'Zona do banco traseiro direito',
    '右后座椅滑轨': 'Carril do banco traseiro direito',
    '右后安全带': 'Cinto de segurança traseiro direito',
    '右后地毯（含周边饰条、饰板）': 'Tapete traseiro direito (inclui frisos e painéis circundantes)',
    '右B柱内饰板': 'Forro do pilar B direito',
    '右C柱内饰板': 'Forro do pilar C direito',
    '右后顶棚': 'Teto traseiro direito',
    '右A柱外侧': 'Pilar A direito exterior',
    '右前车顶': 'Teto dianteiro direito',
    '右前门玻璃': 'Vidro da porta dianteira direita',
    '右前门外侧': 'Painel exterior da porta dianteira direita',
    '右前门裙边外侧': 'Lateral exterior do umbral da porta dianteira direita',
    '右前门内侧': 'Painel interior da porta dianteira direita',
    '右前门内饰（含胶条）': 'Forro da porta dianteira direita (inclui vedantes)',
    '右A柱内侧': 'Pilar A direito interior',
    '右前门裙边内侧': 'Lateral interior do umbral da porta dianteira direita',
    '副驾座椅区域': 'Zona do banco do passageiro',
    '副驾座椅滑轨': 'Carril do banco do passageiro',
    '副驾安全带': 'Cinto de segurança do passageiro',
    '右前地毯（含周边饰条、饰板）': 'Tapete dianteiro direito (inclui frisos e painéis circundantes)',
    '副驾仪表台': 'Tablier do passageiro',
    '右A柱内饰板': 'Forro do pilar A direito',
    '杂物箱': 'Porta-luvas',
    '右前顶棚（含前排天窗饰板、遮阳板）': 'Teto dianteiro direito (inclui forro do teto de abrir e palas de sol)',
    '右前轮胎': 'Pneu dianteiro direito',
    '右前轮毂': 'Jante dianteira direita',
    '右前避震器': 'Amortecedor dianteiro direito',
    '右前轮内衬罩': 'Forro do vão da roda dianteiro direito',
    '右前翼子板': 'Guarda-lamas dianteiro direito',
    '右后视镜': 'Espelho lateral direito',
    '右前大灯': 'Farol dianteiro direito',
    '右前雾灯': 'Luz de nevoeiro dianteira direita',
    '启动': 'Arranque',
    '变速箱': 'Caixa de velocidades',
    '排烟': 'Fumo de escape',
    '无钥匙进入': 'Entrada sem chave',
    '仪表盘功能自检': 'Autodiagnóstico do painel de instrumentos',
    '转向助力': 'Direção assistida',
    '电动后视镜功能': 'Função dos espelhos elétricos',
    '中控锁': 'Fecho centralizado',
    '电动吸合门': 'Portas de fecho assistido',
    '电动座椅': 'Bancos elétricos',
    '座椅记忆': 'Memória do banco',
    '座椅加热': 'Aquecimento dos bancos',
    '座椅通风': 'Ventilação dos bancos',
    '座椅按摩': 'Massagem dos bancos',
    '主驾驶电动门窗总控': 'Comando principal dos vidros elétricos do condutor',
    '灯光系统': 'Sistema de iluminação',
    '前驻车雷达': 'Sensores de estacionamento dianteiros',
    '后驻车雷达': 'Sensores de estacionamento traseiros',
    '倒车影像': 'Câmara de marcha atrás',
    '全景摄像头': 'Câmara panorâmica',
    '可变悬架': 'Suspensão adaptativa',
    '车载冰箱': 'Frigorífico de bordo',
    '室内灯': 'Iluminação interior',
    '天窗': 'Teto de abrir',
    '雨刷': 'Limpa-para-brisas',
    '多功能方向盘': 'Volante multifunções',
    '方向盘换挡拨片': 'Patilhas de mudanças no volante',
    '方向盘加热': 'Volante aquecido',
    '方向盘记忆': 'Memória do volante',
    '空调': 'Ar condicionado',
    '电动门': 'Portas elétricas',
    '电动车窗': 'Vidros elétricos',
    '后排电动遮阳帘': 'Cortina elétrica traseira',
    '后排液晶屏': 'Ecrã LCD traseiro',
    '玻璃顶电动饰板': 'Forro elétrico do teto de vidro',
    '硬顶敞篷': 'Descapotável de teto rígido',
    '发动机': 'Motor',
    '多媒体系统': 'Sistema multimédia',
    '动力电池包安装点': 'Pontos de fixação do bloco de baterias de tração',
    '动力电池包': 'Bloco de baterias de tração',
    '驱动电机(可见部分)': 'Motor de tração (parte visível)',
    '逆变器(可见部分)': 'Inversor (parte visível)',
    '车身高压线束(可见部分)': 'Feixe de alta tensão da carroçaria (parte visível)',
    '随车充电枪': 'Carregador portátil',
    '车辆充电口': 'Porta de carregamento do veículo',
    '增程器': 'Extensor de autonomia',
    '动力系统故障码': 'Código de avaria do grupo motopropulsor',
    '车辆充电故障': 'Avaria de carregamento do veículo',
  },

  // 缺陷名称
  defect: {
    '安装不良': 'Instalação deficiente',
    '常转': 'Funcionamento contínuo',
    '超出上限': 'Acima do limite superior',
    '闯档': 'Engate brusco de velocidade',
    '篡改': 'Alteração indevida',
    '打齿异响': 'Ruído de engrenagens',
    '打滑': 'Patinação',
    '打磨': 'Polimento',
    '灯内异物': 'Corpo estranho no farol',
    '低于下限': 'Abaixo do limite inferior',
    '断裂': 'Fratura',
    '钣金修复': 'Reparação de chapa',
    '改装': 'Modificação',
    '更换': 'Substituição',
    '功能失效': 'Sem funcionamento',
    '鼓包': 'Abaulamento',
    '故障': 'Avaria',
    '后打胶': 'Reaplicação do vedante na traseira',
    '花屏': 'Distorção do ecrã',
    '划痕': 'Risco',
    '划伤': 'Arranhão',
    '晃动': 'Folga / oscilação',
    '变形': 'Deformação',
    '浑浊': 'Líquido turvo',
    '胶套损坏': 'Fole danificado',
    '胶体异常': 'Vedante anómalo',
    '胶条异常': 'Guarnição anómala',
    '卡滞': 'Encravamento',
    '空转': 'Rotação livre',
    '老化': 'Envelhecimento',
    '裂纹': 'Fissura',
    '冒白烟': 'Fumo branco',
    '冒黑烟': 'Fumo preto',
    '不出风': 'Sem saída de ar',
    '冒蓝烟': 'Fumo azul',
    '霉斑': 'Manchas de bolor',
    '磨损': 'Desgaste',
    '泥沙': 'Lama e sedimentos',
    '喷漆': 'Repintura',
    '偏磨': 'Desgaste irregular',
    '破裂': 'Rutura',
    '破损': 'Dano',
    '启动困难': 'Arranque difícil',
    '气囊爆裂': 'Disparo do airbag',
    '不跳档': 'Não muda de velocidade',
    '切割': 'Corte',
    '缺失': 'Peça em falta',
    '缺损': 'Falta de material',
    '缺线': 'Cablagem em falta',
    '入档困难': 'Engate de velocidade difícil',
    '色差': 'Diferença de cor',
    '烧烫': 'Queimadura',
    '渗水': 'Infiltração de água',
    '渗油': 'Sujamento de óleo',
    '失效': 'Fora de função',
    '不制冷': 'Não arrefece',
    '水雾': 'Embaçamento',
    '松动': 'Afrouxamento',
    '松旷': 'Folga excessiva',
    '损坏': 'Partido',
    '损伤': 'Zona danificada',
    '塌陷': 'Abatimento',
    '调节失效': 'Falha de regulação',
    '贴膜起泡': 'Bolhas no filme',
    '脱档': 'Saída de velocidade',
    '污渍': 'Nódoas',
    '不走车': 'O veículo não anda',
    '响应慢': 'Resposta lenta',
    '修复': 'Reparação',
    '锈蚀': 'Corrosão',
    '异味': 'Odor',
    '异响': 'Ruído anómalo',
    '怠速不稳': 'Ralenti instável',
    '怠速过高': 'Ralenti elevado',
    '给不上油': 'Sem fornecimento de combustível',
    '加速抖动': 'Vibração na aceleração',
    '缺缸': 'Falha de cilindro',
    '部件缺失': 'Peças em falta',
    '气门异响': 'Ruído das válvulas',
    '内部异响': 'Ruído interno',
    '轮组异响': 'Ruído do conjunto da roda',
    '窜气': 'Passagem de gases (blow-by)',
    '排气异响': 'Ruído do escape',
    '水渍': 'Mancha de água',
    '凹陷': 'Amolgadela',
    '车门更换': 'Porta substituída',
    '拆卸': 'Desmontagem',
    '后盖更换': 'Tampa da bagageira substituída',
    '机盖更换': 'Capô substituído',
    '内饰更换': 'Interior substituído',
    '焊接': 'Soldadura',
    '开裂': 'Fendilhamento',
    '剐蹭划伤': 'Arranhões e riscos',
    '渗漏': 'Fuga',
    '火烧': 'Queimadura por incêndio',
    '抖动': 'Tremor',
    '动力电池故障': 'Avaria do bloco de baterias de tração',
    '驱动电机故障': 'Avaria do motor de tração',
    '其他': 'Outros',
    '快充故障': 'Avaria de carregamento rápido',
    '慢充故障': 'Avaria de carregamento lento',
    '过火': 'Vestígios de fogo',
    '缺气': 'Pressão de ar insuficiente',
  },

  // 等级
  grade: {
    'A': 'Grau A',
    'B': 'Grau B',
    'C': 'Grau C',
    'D': 'Grau D',
  },

  // 综合描述模板关键词
  description: {
    '外观无换件': 'Sem peças exteriores substituídas',
    '外观原漆': 'Pintura original',
    '外观无需整备成本': 'Sem custo de preparação exterior',
    '内饰正常使用痕迹': 'Sinais normais de uso no interior',
    '车辆无骨架损伤': 'Sem danos na estrutura',
    '发动机工况无异常': 'Estado do motor normal',
    '变速器原地试车无异常': 'Teste estático da caixa de velocidades normal',
  },

  // 通用
  common: {
    '项': 'itens',
    '项异常': 'itens anormais',
    '分': 'pts',
    '级': 'Grau',
    '检测': 'Inspeção',
    '图片': 'Imagem',
    '加载失败': 'Falha ao carregar',
    '加载中...': 'Carregando...',
  },

  // 页面标题
  title: {
    '车况检测': 'Inspeção do estado do veículo',
    '综合描述': 'Descrição geral',
    '综合': 'Geral',
  },

  // 提示文案
  tips: {
    '源于出险数据': '(Com base em dados de sinistros)',
    '车辆是否曾进水(漏水/涉水/水泡)': 'O veículo já esteve exposto à água (infiltração/atravessar água/inundação)?',
    '是': 'Sim',
    '否': 'Não',
    '查看原图': 'Ver imagem original',
  },

  // 评分规则标题
  ruleTitle: {
    '外观评分规则': 'Regras de pontuação do exterior',
    '骨架评级规则': 'Regras de avaliação da estrutura',
    '内饰评分规则': 'Regras de pontuação do interior',
    '综合评级规则': 'Regras de avaliação geral',
  },

  // 外观评分说明
  exteriorRule: {
    '外观准新': 'Estado exterior quase novo',
    '外观较好': 'Estado exterior bom',
    '外观一般': 'Estado exterior razoável',
    '外观较差': 'Estado exterior mau',
    '外观极差': 'Estado exterior extremamente mau',
  },

  // 内饰评分说明
  interiorRule: {
    '内饰准新': 'Estado interior quase novo',
    '内饰较好': 'Estado interior bom',
    '内饰一般': 'Estado interior razoável',
    '内饰较差': 'Estado interior mau',
    '内饰极差': 'Estado interior extremamente mau',
  },

  // 骨架评级说明
  skeletonRule: {
    '车辆结构件与加强件均无因事故造成的损伤': 'Sem danos por acidente nos elementos estruturais e de reforço do veículo.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'Elementos estruturais sem danos por acidente; danos ligeiros por acidente nos elementos de reforço.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'Elementos estruturais sem danos por acidente; danos graves por acidente nos elementos de reforço.',
    '车辆结构件有因事故造成的损伤': 'Danos por acidente nos elementos estruturais.',
  },

  // 综合评级说明
  overallRule: {
    '骨架等级≥A，外观评分≥90，内饰评分≥90，不可出现更换，切割，锈蚀，泥沙，水渍，部件缺失，霉斑，烧烫和机电模块损伤。': 'Estrutura grau ≥A, pontuação exterior ≥90, pontuação interior ≥90; não são permitidas substituições, cortes, ferrugem, lama, manchas de água, peças em falta, bolor, marcas de queimadura nem danos nos módulos eletromecânicos.',
    '骨架等级≥A，外观评分≥80，内饰评分≥80，不可出现切割，泥沙，水渍，霉斑，锈蚀等损伤。': 'Estrutura grau ≥A, pontuação exterior ≥80, pontuação interior ≥80; não são permitidos cortes, lama, manchas de água, bolor, ferrugem, etc.',
    '骨架等级≥B，外观评分＞40，内饰评分＞40': 'Estrutura grau ≥B, pontuação exterior >40, pontuação interior >40',
    '骨架等级≥C，外观评分≥70，内饰评分≥70': 'Estrutura grau ≥C, pontuação exterior ≥70, pontuação interior ≥70',
    '骨架等级≥D，外观评分≥60，内饰评分≥50': 'Estrutura grau ≥D, pontuação exterior ≥60, pontuação interior ≥50',
    '骨架等级≥D，外观评分≥50，内饰评分≥40，不可勾选水泡车。': 'Estrutura grau ≥D, pontuação exterior ≥50, pontuação interior ≥40; não é permitido marcar veículo inundado.',
    '骨架等级≥D，外观评分<50，内饰评分<40': 'Estrutura grau ≥D, pontuação exterior <50, pontuação interior <40',
  }
}
